// src/components/ExamDrum.jsx
import React, { useState } from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

const EXAMS = [
    { id: 'celpip', label: 'CELPIP', color: 'bg-green-600', border: 'border-green-800' },
    { id: 'ielts', label: 'IELTS', color: 'bg-red-600', border: 'border-red-800' },
    { id: 'pte', label: 'PTE Core', color: 'bg-blue-600', border: 'border-blue-800' },
    { id: 'toefl', label: 'TOEFL', color: 'bg-purple-600', border: 'border-purple-800' },
    { id: 'custom', label: 'Custom / On Demand', color: 'bg-gray-800', border: 'border-black' }
];

const ExamDrum = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const theta = 360 / EXAMS.length; 
    const radius = 90; // Reduced from 140 to 90 (Tighter circle)

    const rotate = (dir) => {
        setActiveIndex(prev => prev + dir);
    };

    return (
        <div className="flex flex-col items-center mt-12 mb-4">
            <h3 className="text-xs font-bold text-gray-400 mb-4 uppercase tracking-widest">
                Need Certification?
            </h3>
            
            {/* 3D SCENE CONTAINER (Reduced dimensions) */}
            <div className="relative w-64 h-32 perspective-1000 group">
                
                {/* THE ROTATING DRUM */}
                <div 
                    className="relative w-full h-full transition-transform duration-700 ease-out preserve-3d"
                    style={{ transform: `rotateX(${-activeIndex * theta}deg)` }}
                >
                    {EXAMS.map((exam, i) => {
                        const angle = i * theta;
                        return (
                            <div
                                key={exam.id}
                                className={`absolute w-full h-20 left-0 top-1/2 -mt-10 flex items-center justify-center text-lg font-black text-white rounded shadow-md border-b-4 ${exam.color} ${exam.border}`}
                                style={{
                                    transform: `rotateX(${angle}deg) translateZ(${radius}px)`,
                                    opacity: 0.95
                                }}
                            >
                                {exam.label}
                            </div>
                        );
                    })}
                </div>

                {/* GRADIENT OVERLAYS (Fades the top/bottom) */}
                <div className="absolute inset-0 bg-gradient-to-b from-gray-50 via-transparent to-gray-50 pointer-events-none z-10"></div>
                
                {/* CONTROLS (Compact on the side) */}
                <div className="absolute -right-8 top-1/2 -translate-y-1/2 flex flex-col gap-1 z-20">
                    <button onClick={() => rotate(-1)} className="p-1 bg-white rounded shadow hover:bg-gray-50 text-gray-500"><ChevronUp size={16} /></button>
                    <button onClick={() => rotate(1)} className="p-1 bg-white rounded shadow hover:bg-gray-50 text-gray-500"><ChevronDown size={16} /></button>
                </div>
            </div>
            
            <style jsx>{`
                .perspective-1000 { perspective: 1000px; }
                .preserve-3d { transform-style: preserve-3d; }
            `}</style>
        </div>
    );
};

export default ExamDrum;